import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ConnectorProvider, ConnectorView } from './connectors.models';

export const ConnectorsActions = createActionGroup({
  source: 'Connectors',
  events: {
    // Asks for the list. The effect reuses a list that loaded less than CONNECTORS_REUSE_WINDOW_MS
    // ago and joins a request already in flight, so a caller that asks in a loop costs at most one
    // request per window.
    'Load Connectors': emptyProps(),
    // The person's connections just changed (a consent returned, a disconnect, another tab): always
    // fetch, whatever the window says.
    'Reload Connectors': emptyProps(),
    'Load Connectors Success': props<{ connectors: ConnectorView[] }>(),
    'Load Connectors Failure': props<{ error: string }>(),
    /** A `Load Connectors` the effect answered with the list already in the store. */
    'Load Connectors Skipped': emptyProps(),

    // Leaves the app entirely: a top-level navigation to the API, which redirects to the provider.
    'Connect Provider': props<{ provider: ConnectorProvider }>(),

    'Disconnect Provider': props<{ provider: ConnectorProvider }>(),
    'Disconnect Provider Success': props<{ provider: ConnectorProvider }>(),
    'Disconnect Provider Failure': props<{
      provider: ConnectorProvider;
      error: string;
    }>(),

    /** Callback outcome; map URL-supplied failure codes to translated messages. */
    'Authorization Returned': props<{
      provider: ConnectorProvider;
      reason: string | null;
    }>(),
  },
});
